export const apiMutationKeys = {
  getQuoteSummary: ['getQuoteSummary'],
  cmsFormSubmit: (url: string) => ['cmsFormSubmit', url],
  basicLogin: 'basicLogin',
  sendOTP: (customerId: string | null) => ['sendOTP', customerId],
};
